import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { useParams } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Main } from '@/components/layout/main'
import { StrategyDiffViewer } from '@/features/scoring/components/strategy-diff-viewer'

const diffSearchSchema = z.object({
  left: z.number().optional(),
  right: z.number().optional(),
})

function StrategyDiffPage() {
  const { conversationId } = useParams({
    from: '/_authenticated/scoring/$conversationId/diff',
  })
  const { left, right } = Route.useSearch()

  return (
    <Main>
      <div className='space-y-4'>
        <div className='flex items-center gap-3'>
          <Button
            variant='ghost'
            size='icon'
            onClick={() => window.history.back()}
          >
            <ArrowLeft className='h-4 w-4' />
          </Button>
          <div>
            <h1 className='font-display text-lg font-semibold'>
              Version Comparison
            </h1>
            <p className='text-xs text-muted-foreground'>
              Compare scoring strategy versions
            </p>
          </div>
        </div>

        <StrategyDiffViewer
          conversationId={conversationId}
          initialLeftVersion={left}
          initialRightVersion={right}
        />
      </div>
    </Main>
  )
}

export const Route = createFileRoute(
  '/_authenticated/scoring/$conversationId/diff'
)({
  validateSearch: diffSearchSchema,
  component: StrategyDiffPage,
})
